import QueryParam from './QueryParam';

export default class Module {
    constructor(title, index, type, firstQuestion) {


        this._title = title;
        this._firstQuestion = firstQuestion;
        this._type = type;
        this._index = index;
        this._isActive = true;
        this._wasValidated = false;
        this.reset() // init summary & userInput
    }

    get wasValidated() {
        return this._wasValidated;
    }

    set wasValidated(wasValidated) {
        this._wasValidated = wasValidated;
    }

    get isActive() {
        return this._isActive;
    }

    set isActive(isActive) {
        this._isActive = isActive;
    }

    get index() {
        return this._index;
    }

    set index(index) {
        this._index = index;
    }


    get type() {
        return this._type;
    }

    set type(type) {
        this._type = type;
    }


    get title() {
        return this._title;
    }

    set title(title) {
        this._title = title;
    }

    get firstQuestion() {
        return this._firstQuestion;
    }

    set firstQuestion(firstQuestion) {
        this._firstQuestion = firstQuestion;
    }

    get userInputs() {
        return this._userInputs;
    }

    setUserInput(name, value) {
        if (value == null) {
            delete this._userInputs[name];
        } else {
            this._userInputs[name] = value;
        }
    }

    fieldName(name) {
        return 'blocks[' + (this.index + 100) + '][' + name + ']';
    }

    get summary() {
        return this._summary;
    }

    addToSummary(summaryEntry) {
        this._summary.push(summaryEntry);
    }

    deleteFromSummary(summaryEntryLabel) {
        if (typeof summaryEntryLabel !== 'string') {
            throw "expected summaryEntryLabel to be String"
        }
        this._summary = this._summary.filter(summaryEntry => summaryEntry.label !== summaryEntryLabel)
    }

    clearSummary() {
        this._summary = this._summary?.filter(summaryEntry => summaryEntry.noClear) || [];
    }

    clearUserInputs() {
        this._userInputs = {};
    }

    disable() {
        this.isActive = false;
        this.reset()
    }

    reset() {
        this.clearUserInputs()
        this.clearSummary()
    }

    debugSummaryString() {
        return Object.values(this._summary).map(se => se.label + ": " + se.text).join("\n")
    }

    // presentDates are cleared after user input new date
    _setPresetDatesFromConfigOrQueryParams(datesFromConfig) {
        this._presetDates = {
            checkin: QueryParam.getQueryVariable('checkin') || datesFromConfig.checkin,
            checkout: QueryParam.getQueryVariable('checkout') || datesFromConfig.checkout,
        }
    }
}